// IOS SAFARI LABEL FOR WORKAROUND
// ios safari will not click nested label for inputs/elements
// has to be touchend: click is sometimes triggered after a second touch
// in order to let the first touch only display hover effekts...
$(document).on('touchend', '[data-label-for]', function _(event) {
  event.stopPropagation();
  event.preventDefault();

  const $this = $(this);
  const forAttr = $this.attr('for');
  const $forElem = $(`[id="${forAttr}"]`);

  $forElem.click();
});
